import React from "react";
import { Box, Stack, Chip } from "@mui/material";

function ShowFilters({ filters, handleDelete }) {
  function hasValue(object) {
    return Object.values(object).some((value) => value);
  }

  const labelMap = {
    followers: (val) => val["range"],
    age: (val) => val["agerange"],
    reelCost: (val) => val["reelcostrange"],
    realCost: (val) => {
      const [mn, mx] = (val["realcostrange"] || "").split("-");
      return `Last Paid: ₹${Number(mn).toLocaleString("en-IN")} – ₹${Number(mx).toLocaleString("en-IN")}`;
    },
    brands: (val) => {
      if (!Array.isArray(val) || !val.length) return null;
      return val.length === 1 ? `Brand: ${val[0].name}` : `Brands: ${val.map(b => b.name).join(", ")}`;
    },
    categories: (val) => {
      if (!Array.isArray(val) || !val.length) return null;
      return val.length === 1 ? `Category: ${val[0]}` : `Categories: ${val.join(", ")}`;
    },
    languages: (val) => {
      if (!Array.isArray(val) || !val.length) return null;
      return val.length === 1 ? `Language: ${val[0]}` : `Languages: ${val.join(", ")}`;
    },
    gender: (val) => val === "M" ? "Male" : val === "F" ? "Female" : "Other",
    platform: (val) => ({ Instagram: "Instagram", Twitter: "X (Twitter)", Linkedin: "LinkedIn" })[val] || "Youtube",
    engagedCreators: () => "Engaged Creators",
    cpe: (val) => {
      if (!val?.cperange) return null;
      const [mn, mx] = val.cperange.split('-');
      const parts = [];
      if (mn !== '') parts.push(`≥ ₹${mn}`);
      if (mx !== '') parts.push(`≤ ₹${mx}`);
      return parts.length ? `CPE: ${parts.join(' ')}` : null;
    },
    cpv: (val) => {
      if (!val?.cpvrange) return null;
      const [mn, mx] = val.cpvrange.split('-');
      const parts = [];
      if (mn !== '') parts.push(`≥ ₹${mn}`);
      if (mx !== '') parts.push(`≤ ₹${mx}`);
      return parts.length ? `CPV: ${parts.join(' ')}` : null;
    },
    ratingFilters: (val) => {
      if (!Array.isArray(val)) return null;
      if (!val.length) return '★ Flagged: Any Rating';
      const sorted = [...val].sort((a, b) => b - a);
      return `★ Flagged: ${sorted.join(', ')} star${sorted.length > 1 ? 's' : ''}`;
    },
    location: (val) => val,
  };

  const chipSx = {
    marginBottom: 1,
    fontFamily: 'Quicksand',
    fontWeight: 700,
    fontSize: '0.72rem',
    bgcolor: 'rgba(255,82,0,0.1)',
    color: '#CC4200',
    border: '1px solid rgba(255,82,0,0.3)',
    '& .MuiChip-deleteIcon': { color: 'rgba(204,66,0,0.6)', '&:hover': { color: '#CC4200' } },
    '&:hover': { bgcolor: 'rgba(255,82,0,0.18)' },
    transition: 'all 0.15s ease',
  };

  return (
    hasValue(filters) && (
      <Box sx={{ padding: 1 }}>
        <Stack direction="row" flexWrap="wrap" spacing={1}>
          {Object.keys(filters).map((item) => {
            const value = filters[item];

            if (value === null || value === undefined || value === "" || value === false) {
              return null;
            }

            if (item === "search" && Array.isArray(value)) {
              return value.map((subItem, subIndex) => (
                <Chip
                  label={subItem}
                  variant="filled"
                  onDelete={() => handleDelete(item, subIndex)}
                  key={`${item}-${subIndex}`}
                  sx={chipSx}
                />
              ));
            }

            const label = labelMap[item] ? labelMap[item](value) : value;

            if (typeof label === "boolean" || label === null || label === undefined) {
              return null;
            }

            return (
              <Chip
                key={item}
                label={label}
                variant="filled"
                onDelete={() => handleDelete(item)}
                sx={chipSx}
              />
            );
          })}
        </Stack>
      </Box>
    )
  );
}

export default ShowFilters;
